import { sendEvent } from "@utils/core/track";

export const createAccount = () => {
	sendEvent({ eventId: 'EAF_ca02402c86040d3f' })
	sendEvent({ eventId: 'visit_createpage' })
}
export const signupGetTheCode = () => {
	sendEvent({ eventId: 'EAF_db5280c822f3aacf' })
}
export const signupJoin = () => {
	sendEvent({ eventId: 'EAF_07aeec3c09ebb562' })
}
export const fillSubmit = () => {
	sendEvent({ eventId: 'EAF_afcb3fe7364a6fd3' })
}
export const login = () => {
	sendEvent({ eventId: 'EAF_87893be1c856e281' })
}
export const loginModeChange = () => {
	sendEvent({ eventId: 'EAF_64f0e1bdee78dcd4' })
}

export const emailLogin = () => {
	sendEvent({ eventId: 'loginwithmail' })
}

export const changeToEmailLogin = () => {
	sendEvent({ eventId: 'loginwithmail_toggle' })
}

export const emailForgotPwdStep1 = () => {
	sendEvent({ eventId: 'updatepassword_inputmail' })
}

export const emailForgotPwdStep2 = () => {
	sendEvent({ eventId: 'updatepassword_cofirm_code_mail' })
}

export const emailForgotPwdStep3 = () => {
	sendEvent({ eventId: 'updatepassword_cofirmpw' })
}

export const emailForgotPwdStep4 = () => {
	sendEvent({ eventId: 'updatepassword_done' })
}

export const emailCreateAccount = () => {
	sendEvent({ eventId: 'createaccountwithmail' })
}

export const changeToEmailCreateAccount = () => {
	sendEvent({ eventId: 'createaccountwithmail_toggle' })
}

export const emailSignupJoin = () => {
	sendEvent({ eventId: 'createaccountwithmail_join' })
}

export const emailSignupResendCode = () => {
	sendEvent({ eventId: 'createaccountwithmail_resendcode' })
}
